import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";

interface RemoveUserGroupMemberParams {
  groupId: string;
  userId: string;
}

export function useRemoveUserGroupMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ groupId, userId }: RemoveUserGroupMemberParams) =>
      api.removeUserGroupMember(groupId, userId),
    onSuccess: (_data, { groupId }) => {
      queryClient.invalidateQueries({
        queryKey: ["user-groups", groupId, "members"],
      });
    },
  });
}
